export default function getQuery (search: string, queryItem: string): string|null {
  const parameters = new URLSearchParams(search)
  const param = parameters.get(queryItem)

  return param
}
